"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachment = void 0;
var joi_1 = __importDefault(require("joi"));
var metadata_1 = require("./attachment/metadata");
var submitter_1 = require("./attachment/submitter");
exports.attachment = joi_1.default.object({
    documentID: joi_1.default.string()
        .guid({ version: ['uuidv4', 'uuidv5'] })
        .required(),
    metadata: metadata_1.metadata,
    submitter: submitter_1.submitter,
});
exports.default = { attachment: exports.attachment };
